export default __webpack_public_path__ + "static/media/CONTRUCCION_DASHBOARD_IMG.7c761294.jpg";